/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import cn from 'clsx';
import { AButton, ACheckbox } from 'components/Antd';
import { ReactComponent as AISuggestionStarSvg } from 'assets/icons/New/ai-suggestion-star.svg';
import { ReactComponent as AIExportSvg } from 'assets/icons/New/ai-export.svg';
import { ReactComponent as AIPlusSvg } from 'assets/icons/New/ai-plus.svg';
import { AI_DATA_ARR, getAIData } from './data';
import classes from './AIModal.module.scss';

const Success = ({ className, onBack, onExport, onAdd, form, data, onChecksChange }) => {
  const [exportLoading, setExportLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const suggestions = !!data ? getAIData(data) : AI_DATA_ARR;
  const values = form.getFieldsValue();
  const summary = [
    {
      label: 'Product Name',
      value: values?.product_name,
    },
    {
      label: 'Import Country',
      value: values?.import_country,
    },
    {
      label: 'Product Intended Used By',
      value: values?.product_intend,
    },
    {
      label: 'Product Description & Product Highlight',
      value: values?.product_description,
    },
  ];
  const summaryContent = (
    <>
      <div>Product Summary</div>
      {summary.map((obj, index) => {
        return (
          <div className={classes.summaryItem} key={index}>
            <span>{obj.label}</span>
            <span>{obj.value}</span>
          </div>
        );
      })}
    </>
  );
  const noteEl = (
    <>
      <span>Disclaimer:</span>
      <span>
        The information provided here is for reference only and may not be completely up-to-date or
        validated. If you need further clarification, we recommend contacting our Customer Success
        Manager.
      </span>
    </>
  );
  const mainContentEl = (
    <>
      <div className={classes.successCaption}>
        <span>
          Generated successfully. You can view it here and add items to Quality Requirement.{' '}
        </span>
      </div>
      <div className={classes.productSummary}>{summaryContent}</div>
      <div className={classes.successSuggestion}>
        <h3>
          <AISuggestionStarSvg />
          <span>AI Suggestion</span>
        </h3>
        <ul>
          {suggestions.map((suggestion, index) => {
            return (
              <li key={index}>
                <div className={classes.successSuggestionTitle}>
                  <span>{suggestion.text}</span>
                  <span>The described product must comply with the following:</span>
                </div>
                <div className={classes.successSuggestionFields}>
                  {suggestion.items.map((item, fieldIndex) => {
                    return (
                      <div className={classes.successSuggestionField} key={fieldIndex}>
                        {!!item.title && <span className={classes.sItemTitle}>{item.title}</span>}
                        {!item.fieldName ? (
                          <div className={classes.sItemLabelField}>
                            <span className={classes.sItemFieldTitle}>{item.fieldTitle}</span>
                            {item.fieldGroup ? (
                              <>
                                {(item.fieldDescriptions || []).map((v, vIndex) => {
                                  return <span key={vIndex}>{v}</span>;
                                })}
                              </>
                            ) : (
                              <>
                                {!!item.fieldDescription && (
                                  <span className={classes.sItemFieldDescription}>
                                    {item.fieldDescription}
                                  </span>
                                )}
                              </>
                            )}
                          </div>
                        ) : (
                          <div>
                            <ACheckbox
                              defaultChecked
                              className={classes.sItemCheckbox}
                              onChange={(e) => {
                                const tChecked = e.target.checked;
                                if (onChecksChange) {
                                  onChecksChange({
                                    [item.fieldName]: tChecked,
                                  });
                                }
                              }}>
                              {item.fieldTitle}
                            </ACheckbox>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </li>
            );
          })}
        </ul>
      </div>
      <div className={classes.successNote}>{noteEl}</div>
    </>
  );
  return (
    <>
      <div className={cn(classes.successWrapper, className)} id="ai-pdf-export">
        {mainContentEl}
        <div className={cn(classes.footer, classes.successFooter)}>
          <AButton
            htmlType="button"
            type="ghost"
            size="large"
            onClick={onBack}
            className={classes.backBtn}>
            Back
          </AButton>
          <AButton
            htmlType="button"
            type="primary"
            size="large"
            loading={exportLoading}
            onClick={() => {
              if (onExport) {
                setExportLoading(true);
                onExport(() => {
                  setExportLoading(false);
                });
              }
            }}
            icon={<AIExportSvg />}
            className={classes.confirmBtn}>
            Export to PDF
          </AButton>
          <AButton
            htmlType="button"
            type="primary"
            size="large"
            loading={loading}
            onClick={() => {
              if (onAdd) {
                setLoading(true);
                onAdd(() => {
                  setLoading(false);
                });
              }
            }}
            icon={<AIPlusSvg />}
            className={classes.confirmBtn}>
            Add to Requirement
          </AButton>
        </div>
      </div>
    </>
  );
};

export default Success;
